module.exports = __webpack_public_path__ + "static/media/logo.38edcd4e.png";